import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { $rqSmartFoldersApiClient, $rqViewsApiClient } from "@/api/groups"
import { provisioningSSEQuery } from "@/api/hooks/useSSEProvision"
import { query } from "@/api/query"
import { getBoardsQueryOptions } from "@/api/query/boardsQueryOptions"
import { getXOrganizationHeaders } from "@/api/utils"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/devices")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: ({ context: { queryClient, spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient.query(query.space.members(space)).catch(noop)
    queryClient.query(getBoardsQueryOptions()).catch(noop)

    queryClient
      .query(
        $rqViewsApiClient.queryOptions("get", "/groups/v1/devices", {
          params: {
            header: getXOrganizationHeaders(space)
          }
        })
      )
      .catch(noop)

    queryClient.query(provisioningSSEQuery(space)).catch(noop)

    queryClient
      .query(
        $rqViewsApiClient.queryOptions("get", "/groups/v1/things", {
          params: {
            header: getXOrganizationHeaders(space)
          }
        })
      )
      .catch(noop)

    queryClient
      .query(
        $rqSmartFoldersApiClient.queryOptions("get", "/groups/v1/smartfolders", {
          params: {
            header: getXOrganizationHeaders(space)
          }
        })
      )
      .catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "Devices | Arduino Cloud"
      }
    ]
  })
})
